var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Client Settings")]),(!_vm.loading)?_c('ChirpSettings',{attrs:{"data_source":_vm.rows,"level":'client',"level_id":_vm.level_id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }